import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { SiteProvider } from '../models/siteProvider.ts';
import { fetchSiteProviders } from '../api/site-provider.ts';

export default function useSiteProviders(): UseQueryResult<
  SiteProvider[],
  Error
> {
  const queryFn = fetchSiteProviders;
  return useQuery<SiteProvider[]>({ queryKey: ['siteProviders'], queryFn });
}
